module.exports = __webpack_public_path__ + "static/media/telemedicine.1a795898.jpg";